import React, { useState, useEffect, useRef } from "react";
import {
  Divider,
  Typography,
  Checkbox,
  Box,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useQuery, useMutation, useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { Card, CardContent, CardActions } from "../../components/Card";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import { Select, TextInput, DateInput } from "../../components/Form";
import TrackRecordTable from "./TrackRecordTable";
import TargetPropertyTable from "./TargetPropertyTable";
import Address from "./Address";
import { useAlert } from "../../components/Alert";
import LoadingModal from "../../components/LoadingModal";
import { propertyDataArray } from "../../components/PropertyDataArray";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SAVE_CUSTOMER = gql`
  mutation saveCustomer($customerInput: CustomerInput!) {
    saveCustomer(customerInput: $customerInput)
  }
`;
const GET_CUSTOMER = gql`
  query customer($id: Int!) {
    customer(id: $id) {
      id
      salesperson {
        id
        fullName
      }
      franchiseStore {
        id
        name
      }
      address
      joinCourseDeposit
      joinCourseDate
      franchiseDeposit
      franchiseDate
      remark
      customerType
      source
      willingness
      customerStatus
      customerInfo {
        id
        fullName
        gender
        mobile1
        mobile2
        line
        weChat
        email
      }
      customerDemand {
        id
        transfer
        demandPriceFrom
        demandPriceTo
        demandLandPingFrom
        demandLandPingTo
        demandBuildPingFrom
        demandBuildPingTo
        caseName
        floor
        elevator
        houseStatus
        parkingSpace
        administrator
        room
        livingroom
        bathroom
        managementFee
        overview
      }
    }
  }
`;
const GET_FRANCHISESTORES = gql`
  query franchiseStores($latest: Boolean, $pageSize: Int, $page: Int) {
    franchiseStores(latest: $latest, pageSize: $pageSize, page: $page) {
      contents {
        id
        name
      }
    }
  }
`;

const GET_USERS = gql`
  query users(
    $latest: Boolean
    $identity: Identity
    $pageSize: Int
    $page: Int
  ) {
    users(
      latest: $latest
      identity: $identity
      pageSize: $pageSize
      page: $page
    ) {
      contents {
        id
        fullName
      }
    }
  }
`;

const REGULARADDTRACKRECORD = gql`
  mutation regularAddTrackRecord($id: Int!) {
    regularAddTrackRecord(id: $id)
  }
`;

export default function EditCustomerTable({
  areaData = [],
  onChangeAreaData = () => {},
  simulationQuery,
  onChangeSelect = () => {},
}) {
  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      justifyContent: "flex-end",
    },
    DocumentContainerBetween: {
      alignItems: "center",
      //flexDirection: "row",
      justifyContent: "space-between",
    },
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
  });
  const classes = useStyles();
  const Alert = useAlert();
  const {
    customerAttributesArray,
    customerSourceArray,
    wishArray,
    typeHouseArray,
    pointHandArray,
    elevatorArray,
    houseStateArray,
    parkingArray,
    adminArray,
    foreclosureStatusArray,
    franchiseeStatusArray,
  } = propertyDataArray();
  const [newData, setNewData] = useState({
    franchiseStoreArray: [],
    franchiseStoreObject: { label: "", value: undefined },
    customerStatusObject: { label: "", value: undefined },
    salespersonArray: [],
    salespersonObject: { label: "", value: undefined },
    customerSourceObject: { label: "", value: undefined },
    customerAttributesObject: { label: "", value: undefined },
    wishObject: { label: "", value: undefined },
    pointHandObject: { label: "", value: undefined },
    typeHouseObject: [],
    elevatorObject: { label: "", value: undefined },
    houseStateObject: { label: "", value: undefined },
    parkingObject: { label: "", value: undefined },
    adminObject: { label: "", value: undefined },
    edit: simulationQuery === undefined ? true : false,
    customerId1: "",
    customerId2: "",
    customerNumber: "",
    customerName1: "",
    customerName2: "",
    gender1: "",
    gender2: "",
    phone1_1: "",
    phone1_2: "",
    phone2_1: "",
    phone2_2: "",
    LINE_1: "",
    weChat_1: "",
    email_1: "",
    LINE_2: "",
    weChat_2: "",
    email_2: "",
    address: "",
    fileDate: moment().format("YYYY-MM-DD"),
    classDeposit: "",
    affiliateDeposit: "",
    classDate: null,
    affiliateDate: null,
    remark: "",
    areaData: [],
    floorStart: "",
    floorEnd: "",
    jianpingStart: "",
    jianpingEnd: "",
    priceStart: "",
    priceEnd: "",
    caseName: "",
    houseAge: "",
    floor: "",
    managementFee: "",
    room: "",
    hall: "",
    guard: "",
    overView: "",
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const { loading: franchiseStoresLoading } = useQuery(GET_FRANCHISESTORES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      pageSize: 999,
      page: 1,
    },
    onCompleted({ franchiseStores }) {
      if (franchiseStores) {
        let newArray = [];
        franchiseStores.contents.map((item) => {
          newArray.push({ label: item.name, value: item.id });
        });
        changeData("franchiseStoreArray", newArray, true);
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  const { loading: usersLoading } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      identity: "STAFF",
      pageSize: 999,
      page: 1,
    },
    onCompleted({ users }) {
      if (users) {
        let newArray = [];
        users.contents.map((item) => {
          newArray.push({ label: item.fullName, value: item.id });
        });
        changeData("salespersonArray", newArray, true);
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });

  const [saveCustomer, { loading: saveCustomerLoading }] = useMutation(
    SAVE_CUSTOMER,
    {
      onCompleted({ saveCustomer }) {
        if (saveCustomer) {
          Alert.notice("儲存成功");
          return onChangeSelect();
        }
      },
      onError(error) {
        return Alert.notice(`欄位未填寫完整！`);
      },
    }
  );

  const [regularAddTrackRecord, { loading: regularAddTrackRecordLoading }] =
    useMutation(REGULARADDTRACKRECORD);
  const [getCustomer, { data: customerData, loading }] = useLazyQuery(
    GET_CUSTOMER,
    {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onCompleted({ customer }) {
        if (customer) {
          if (customer.franchiseStore) {
            changeData("franchiseStoreObject", {
              label: customer.franchiseStore.name,
              value: customer.franchiseStore.id,
            });
          }
          changeData(
            "customerAttributesObject",
            customerAttributesArray.find(
              (item) => item.value === customer.customerType
            )
          );
          changeData(
            "customerSourceObject",
            customerSourceArray.find((item) => item.value === customer.source)
          );
          changeData(
            "wishObject",
            wishArray.find((item) => item.value === customer.willingness)
          );
          changeData("customerName1", customer.customerInfo[0].fullName);
          changeData("customerId1", customer.customerInfo[0].id);
          changeData("gender1", customer.customerInfo[0].gender ?? "");
          changeData("phone1_1", customer.customerInfo[0].mobile1 ?? "");
          changeData("phone1_2", customer.customerInfo[0].mobile2 ?? "");
          changeData("LINE_1", customer.customerInfo[0].line ?? "");
          changeData("weChat_1", customer.customerInfo[0].weChat ?? "");
          changeData("email_1", customer.customerInfo[0].email ?? "");
          if (customer.customerInfo[1]) {
            changeData("customerId2", customer.customerInfo[1].id);
            changeData("customerName2", customer.customerInfo[1].fullName);
            changeData("gender2", customer.customerInfo[1].gender ?? "");
            changeData("phone2_1", customer.customerInfo[1].mobile1 ?? "");
            changeData("phone2_2", customer.customerInfo[1].mobile2 ?? "");
            changeData("LINE_2", customer.customerInfo[1].line ?? "");
            changeData("weChat_2", customer.customerInfo[1].weChat ?? "");
            changeData("email_2", customer.customerInfo[1].email ?? "");
          }

          if (customer.address) changeData("address", customer.address);
          if (customer.salesperson) {
            changeData("salespersonObject", {
              label: customer.salesperson.fullName,
              value: customer.salesperson.id,
            });
          }
          if (customer.joinCourseDeposit)
            changeData("classDeposit", customer.joinCourseDeposit);
          if (customer.joinCourseDate)
            changeData("classDate", customer.joinCourseDate);
          if (customer.franchiseDeposit)
            changeData("affiliateDeposit", customer.franchiseDeposit);
          if (customer.franchiseDate)
            changeData("affiliateDate", customer.franchiseDate);

          if (customer.customerDemand) {
            changeData(
              "pointHandObject",
              pointHandArray.find(
                (item) => item.value === customer.customerDemand.transfer
              )
            );
            changeData("priceStart", customer.customerDemand.demandPriceFrom);
            changeData("priceEnd", customer.customerDemand.demandPriceTo);
            changeData(
              "jianpingStart",
              customer.customerDemand.demandBuildPingFrom
            );
            changeData(
              "jianpingEnd",
              customer.customerDemand.demandBuildPingTo
            );
            changeData(
              "floorStart",
              customer.customerDemand.demandLandPingFrom
            );
            changeData("floorEnd", customer.customerDemand.demandLandPingTo);
            changeData("caseName", customer.customerDemand.caseName);
            changeData("floor", customer.customerDemand.floor);
            changeData("room", customer.customerDemand.room);
            changeData("hall", customer.customerDemand.livingroom);
            changeData("guard", customer.customerDemand.bathroom);
            changeData("managementFee", customer.customerDemand.managementFee);
            changeData("overView", customer.customerDemand.overview);
            changeData(
              "elevatorObject",
              elevatorArray.find(
                (item) => item.value === customer.customerDemand.elevator
              )
            );
            changeData(
              "houseStateObject",
              houseStateArray.find(
                (item) => item.value === customer.customerDemand.houseStatus
              )
            );
            changeData(
              "parkingObject",
              parkingArray.find(
                (item) => item.value === customer.customerDemand.parkingSpace
              )
            );
            changeData(
              "adminObject",
              adminArray.find(
                (item) => item.value === customer.customerDemand.administrator
              )
            );
          }
          changeData("remark", customer.remark, true);
        }
      },
      onError(error) {
        Alert.alert("通知", `${error}`, [
          {
            text: "確定",
            type: "ok",
          },
        ]);
      },
    }
  );
  function save() {
    if (newData.customerName1 === "") {
      return Alert.notice("名字為必填！");
    }
    const customerInput = {
      // franchiseStoreId: newData.franchiseStoreObject.value,
      // salespersonId: newData.salespersonObject.value,
      customerType: newData.customerAttributesObject.value,
      source: newData.customerSourceObject?.value,
      willingness: newData.wishObject?.value,
      assignStatus: "SERVING",
      customerStatus: newData.customerStatusObject?.value,
      address: newData.address,
      joinCourseDeposit: Number(newData.classDeposit),
      joinCourseDate: newData.classDate,
      franchiseDeposit: Number(newData.affiliateDeposit),
      franchiseDate: newData.affiliateDate,
      remark: newData.remark,
      customerInfo: [
        {
          fullName: newData.customerName1,
          gender: newData.gender1 === "" ? null : newData.gender1,
          mobile1: newData.phone1_1,
          mobile2: newData.phone1_2,
          line: newData.LINE_1,
          weChat: newData.weChat_1,
          email: newData.email_1,
        },
      ],
      frontSite: false,
    };

    if (newData.customerName2 !== "") {
      customerInput.customerInfo.push({
        fullName: newData.customerName2,
        gender: newData.gender2,
        mobile1: newData.phone2_1,
        mobile2: newData.phone2_2,
        line: newData.LINE_2,
        weChat: newData.weChat_2,
        email: newData.email_2,
      });
    }

    if (newData.customerId1 !== "") {
      customerInput.customerInfo[0].id = newData.customerId1;
    }
    if (newData.customerId2 !== "") {
      customerInput.customerInfo[1].id = newData.customerId2;
    }

    if (newData.customerAttributesObject.value === "FORECLOSURE") {
      customerInput.customerDemand = {
        transfer: newData.pointHandObject.value,
        demandPriceFrom: Number(newData.priceStart),
        demandPriceTo: Number(newData.priceEnd),
        demandLandPingFrom: Number(newData.floorStart),
        demandLandPingTo: Number(newData.floorEnd),
        demandBuildPingFrom: Number(newData.jianpingStart),
        demandBuildPingTo: Number(newData.jianpingEnd),
        caseName: newData.caseName,
        floor: newData.floor,
        elevator: newData.elevatorObject.value,
        houseStatus: newData.houseStateObject.value,
        parkingSpace: newData.parkingObject.value,
        administrator: newData.adminObject.value,
        room: newData.room,
        livingroom: newData.hall,
        bathroom: newData.guard,
        managementFee: Number(newData.managementFee),
        overview: newData.overView,
      };
    }

    if (!!simulationQuery?.id) {
      customerInput.id = simulationQuery.id;
    }

    // console.log(customerInput);
    saveCustomer({ variables: { customerInput } });
  }
  useEffect(() => {
    console.log(simulationQuery.id);
    if (!!simulationQuery?.id) {
      getCustomer({ variables: { id: simulationQuery.id } });
      regularAddTrackRecord({ variables: { id: simulationQuery.id } });
    }
  }, [simulationQuery]);

  if (franchiseStoresLoading || usersLoading || loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal
          loading={saveCustomerLoading || regularAddTrackRecordLoading}
        />
        {/* <CardContent>
          <Grid container spacing={1} direction="row" alignItems="center">
            <Grid item>
              <Typography color="primary">分店:</Typography>
            </Grid>
            <Grid item sm={2} xs={8}>
              <Select
                items={newData.franchiseStoreArray}
                value={newData.franchiseStoreObject}
                onChange={(e, v) => {
                  if (v) changeData("franchiseStoreObject", v, true);
                  else changeData("franchiseStoreObject", {}, true);
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent> */}
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={1}
            classes={{ root: classes.DocumentContainerBetween }}
          >
            <Grid item>
              <Typography style={{ fontSize: 25 }}>客戶資料</Typography>
            </Grid>
            {simulationQuery !== undefined && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onPress={() => changeData("edit", true, true)}
                >
                  編輯
                </Button>
              </Grid>
            )}
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid xs={6} sm={2} item>
              <Typography color="primary">客戶屬性:</Typography>
              {newData.edit ? (
                <Select
                  items={customerAttributesArray}
                  value={newData.customerAttributesObject}
                  onChange={(e, value) => {
                    if (value)
                      changeData("customerAttributesObject", value, true);
                    else
                      changeData(
                        "customerAttributesObject",
                        { label: "", value: undefined },
                        true
                      );
                  }}
                  fullWidth
                />
              ) : (
                <Typography>
                  {newData.customerAttributesObject.label}
                </Typography>
              )}
            </Grid>
            {newData.customerAttributesObject.value !== "" &&
              newData.customerAttributesObject.value !== "SERVICE_AREA" && (
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">客戶狀態:</Typography>
                  {newData.edit ? (
                    <Select
                      items={
                        newData.customerAttributesObject.value === "FORECLOSURE"
                          ? foreclosureStatusArray
                          : franchiseeStatusArray
                      }
                      value={newData.customerStatusObject}
                      onChange={(e, value) => {
                        if (value)
                          changeData("customerStatusObject", value, true);
                        else
                          changeData(
                            "customerStatusObject",
                            { label: "", value: undefined },
                            true
                          );
                      }}
                      fullWidth
                    />
                  ) : (
                    <Typography>
                      {newData.customerAttributesObject.label}
                    </Typography>
                  )}
                </Grid>
              )}
            <Grid xs={6} sm={2} item>
              <Typography color="primary">來源:</Typography>
              {newData.edit ? (
                <Select
                  items={customerSourceArray}
                  value={newData.customerSourceObject}
                  onChange={(e, value) => {
                    if (value) changeData("customerSourceObject", value, true);
                    else changeData("customerSourceObject", {}, true);
                  }}
                />
              ) : (
                <Typography>{newData.customerSourceObject.label}</Typography>
              )}
            </Grid>
            <Grid xs={6} sm={1} item>
              <Typography color="primary">意願指數:</Typography>
              {newData.edit ? (
                <Select
                  items={wishArray}
                  value={newData.wishObject}
                  onChange={(e, value) => {
                    if (value) changeData("wishObject", value, true);
                    else changeData("wishObject", {}, true);
                  }}
                />
              ) : (
                <Typography>{newData.wishObject?.label}</Typography>
              )}
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid container>
              <Typography>客戶(一)</Typography>
            </Grid>
            <Grid item container spacing={1}>
              <Grid item sm={2} xs={6}>
                <Typography color="primary">姓名:</Typography>
                {newData.edit ? (
                  <TextInput
                    value={newData.customerName1}
                    onChange={(v) => changeData("customerName1", v, true)}
                  />
                ) : (
                  <Typography>{newData.customerName1}</Typography>
                )}
              </Grid>
              <Grid item sm={2} xs={6}>
                <Typography color="primary">姓別:</Typography>
                {newData.edit ? (
                  <Grid item classes={{ root: classes.DocumentContainerRow }}>
                    <Checkbox
                      color="primary"
                      checked={newData.gender1 === "MALE"}
                      onChange={() => changeData("gender1", "MALE", true)}
                    />
                    <Typography color="primary" style={{ fontSize: 15 }}>
                      男
                    </Typography>
                    <Checkbox
                      color="primary"
                      checked={newData.gender1 === "FEMALE"}
                      onChange={() => changeData("gender1", "FEMALE", true)}
                    />
                    <Typography color="primary" style={{ fontSize: 15 }}>
                      女
                    </Typography>
                  </Grid>
                ) : (
                  <Typography>
                    {newData.gender1 === ""
                      ? ""
                      : newData.gender1 === "MALE"
                      ? "男"
                      : "女"}
                  </Typography>
                )}
              </Grid>
              <Grid item>
                <Typography color="primary">電話:</Typography>
                {newData.edit ? (
                  <Grid container>
                    <TextInput
                      value={newData.phone1_1}
                      placeholder="1"
                      onChange={(v) => changeData("phone1_1", v, true)}
                    />
                    {"\u2002"}
                    <TextInput
                      value={newData.phone1_2}
                      placeholder="2"
                      onChange={(v) => changeData("phone1_2", v, true)}
                    />
                  </Grid>
                ) : (
                  <Grid container>
                    <Typography>{newData.phone1_1}</Typography>
                    {"\u2002"}
                    <Typography>{newData.phone1_2}</Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item container spacing={1}>
              <Grid xs={6} sm={3} item>
                <Typography color="primary">LINE:</Typography>
                {newData.edit ? (
                  <TextInput
                    value={newData.LINE_1}
                    onChange={(v) => changeData("LINE_1", v, true)}
                  />
                ) : (
                  <Typography>{newData.LINE_1}</Typography>
                )}
              </Grid>
              <Grid xs={6} sm={3} item>
                <Typography color="primary">微信:</Typography>
                {newData.edit ? (
                  <TextInput
                    value={newData.weChat_1}
                    onChange={(v) => changeData("weChat_1", v, true)}
                  />
                ) : (
                  <Typography>{newData.weChat_1}</Typography>
                )}
              </Grid>
              <Grid xs={6} sm={4} item>
                <Typography color="primary">電子信箱:</Typography>
                {newData.edit ? (
                  <TextInput
                    value={newData.email_1}
                    onChange={(v) => changeData("email_1", v, true)}
                  />
                ) : (
                  <Typography>{newData.email_1}</Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        {((simulationQuery?.id &&
          customerData.customer.customerInfo.length == 2) ||
          !simulationQuery) && (
          <CardContent>
            <Grid container spacing={1}>
              <Grid container>
                <Typography>客戶(二)</Typography>
              </Grid>
              <Grid item container spacing={1}>
                <Grid item sm={2} xs={6}>
                  <Typography color="primary">姓名:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.customerName2}
                      onChange={(v) => changeData("customerName2", v, true)}
                    />
                  ) : (
                    <Typography>{newData.customerName2}</Typography>
                  )}
                </Grid>
                <Grid item sm={2} xs={6}>
                  <Typography color="primary">姓別:</Typography>
                  {newData.edit ? (
                    <Grid item classes={{ root: classes.DocumentContainerRow }}>
                      <Checkbox
                        color="primary"
                        checked={newData.gender2 === "MALE"}
                        onChange={() => changeData("gender2", "MALE", true)}
                      />
                      <Typography color="primary" style={{ fontSize: 15 }}>
                        男
                      </Typography>
                      <Checkbox
                        color="primary"
                        checked={newData.gender2 === "FEMALE"}
                        onChange={() => changeData("gender2", "FEMALE", true)}
                      />
                      <Typography color="primary" style={{ fontSize: 15 }}>
                        女
                      </Typography>
                    </Grid>
                  ) : (
                    <Typography>
                      {newData.gender2 === ""
                        ? ""
                        : newData.gender2 === "MALE"
                        ? "男"
                        : "女"}
                    </Typography>
                  )}
                </Grid>
                <Grid item>
                  <Typography color="primary">電話:</Typography>
                  {newData.edit ? (
                    <Grid container>
                      <TextInput
                        value={newData.phone2_1}
                        placeholder="1"
                        onChange={(v) => changeData("phone2_1", v, true)}
                      />
                      {"\u2002"}
                      <TextInput
                        value={newData.phone2_2}
                        placeholder="2"
                        onChange={(v) => changeData("phone2_2", v, true)}
                      />
                    </Grid>
                  ) : (
                    <Grid container>
                      <Typography>{newData.phone2_1}</Typography>
                      {"\u2002"}
                      <Typography>{newData.phone2_2}</Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item container spacing={1}>
                <Grid xs={6} sm={3} item>
                  <Typography color="primary">LINE:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.LINE_2}
                      onChange={(v) => changeData("LINE_2", v, true)}
                    />
                  ) : (
                    <Typography>{newData.LINE_2}</Typography>
                  )}
                </Grid>
                <Grid xs={6} sm={3} item>
                  <Typography color="primary">微信:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.weChat_2}
                      onChange={(v) => changeData("weChat_2", v, true)}
                    />
                  ) : (
                    <Typography>{newData.weChat_2}</Typography>
                  )}
                </Grid>
                <Grid xs={6} sm={4} item>
                  <Typography color="primary">電子信箱:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.email_2}
                      onChange={(v) => changeData("email_2", v, true)}
                    />
                  ) : (
                    <Typography>{newData.email_2}</Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        )}
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid xs={6} sm={5} item>
              <Typography color="primary">地址:</Typography>
              {newData.edit ? (
                <TextInput
                  value={newData.address}
                  onChange={(v) => changeData("address", v, true)}
                  fullWidth
                />
              ) : (
                <Typography>{newData.address}</Typography>
              )}
            </Grid>
            {/* <Grid xs={6} sm={3} item>
              <Typography color="primary">業務員:</Typography>
              <Select
                items={newData.salespersonArray}
                value={newData.salespersonObject}
                onChange={(e, v) => {
                  if (v) changeData("salespersonObject", v, true);
                  else changeData("salespersonObject", {}, true);
                }}
              />
            </Grid> */}
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid xs={6} sm={2} item>
              <Typography color="primary">上課訂金:</Typography>
              {newData.edit ? (
                <TextInput
                  value={newData.classDeposit}
                  onChange={(v) => changeData("classDeposit", v, true)}
                />
              ) : (
                <Typography>{newData.classDeposit}</Typography>
              )}
            </Grid>
            <Grid xs={6} sm={2} item>
              <Typography color="primary">上課收訂日期:</Typography>
              {newData.edit ? (
                <DateInput
                  inputVariant="outlined"
                  format="yyyy年MM月dd日"
                  value={newData.classDate}
                  onChange={(v) => changeData("classDate", v, true)}
                  fullWidth
                />
              ) : (
                <Typography>
                  {newData.classDate
                    ? moment(newData.classDate).format("yyyy年MM月DD日")
                    : ""}
                </Typography>
              )}
            </Grid>
            <Grid xs={6} sm={2} item>
              <Typography color="primary">加盟訂金:</Typography>
              {newData.edit ? (
                <TextInput
                  value={newData.affiliateDeposit}
                  onChange={(v) => changeData("affiliateDeposit", v, true)}
                />
              ) : (
                <Typography>{newData.affiliateDeposit}</Typography>
              )}
            </Grid>
            <Grid xs={6} sm={2} item>
              <Typography color="primary">加盟收訂日期:</Typography>
              {newData.edit ? (
                <DateInput
                  inputVariant="outlined"
                  format="yyyy年MM月dd日"
                  value={newData.affiliateDate}
                  onChange={(v) => changeData("affiliateDate", v, true)}
                  fullWidth
                />
              ) : (
                <Typography>
                  {newData.affiliateDate
                    ? moment(newData.affiliateDate).format("yyyy年MM月DD日")
                    : ""}
                </Typography>
              )}
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid xs={12} sm={12} item>
              <Typography color="primary">備註:</Typography>
              {newData.edit ? (
                <TextInput
                  value={newData.remark}
                  onChange={(v) => changeData("remark", v, true)}
                  fullWidth
                  multiline
                  rows={10}
                />
              ) : (
                <Typography>{newData.remark}</Typography>
              )}
            </Grid>
          </Grid>
        </CardContent>
        {simulationQuery?.attributes === "法拍" ||
        newData.customerAttributesObject.value === "FORECLOSURE" ? (
          <>
            <Divider />
            <CardContent>
              <Typography style={{ fontSize: 25 }}>客戶需求</Typography>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Address
                  areaData={areaData}
                  onChangeAreaData={onChangeAreaData}
                />
                <Grid xs={12} sm={2} item>
                  <Typography color="primary">需求屋型:</Typography>
                  <Autocomplete
                    multiple
                    size="small"
                    limitTags={1}
                    options={typeHouseArray}
                    disableCloseOnSelect
                    onChange={(e, value, i, j) => {
                      if (j) {
                        const hasOne = newData.typeHouseObject.find(
                          (item2) => item2.value === j.option.value
                        );
                        if (hasOne) {
                          if (j.option.value === "全選") {
                            changeData("typeHouseObject", [], true);
                          } else {
                            newData.typeHouseObject.forEach((item2, index2) => {
                              if (item2.value === j.option.value) {
                                newData.typeHouseObject.splice(index2, 1);
                              }
                            });
                            changeData(
                              "typeHouseObject",
                              newData.typeHouseObject,
                              true
                            );
                          }
                        } else {
                          if (j.option.value === "全選") {
                            const newSelect = [];
                            for (let i = 0; i < typeHouseArray.length; i++) {
                              newSelect.push(typeHouseArray[i]);
                            }
                            changeData("typeHouseObject", newSelect, true);
                          } else {
                            newData.typeHouseObject.push(j.option);
                            changeData(
                              "typeHouseObject",
                              newData.typeHouseObject,
                              true
                            );
                          }
                        }
                      } else {
                        changeData("typeHouseObject", [], true);
                      }
                    }}
                    value={newData.typeHouseObject}
                    getOptionLabel={(option) => option.label}
                    getOptionSelected={(option, value) =>
                      value && option.value === value.value
                    }
                    ListboxProps={{ style: { maxHeight: "14.5rem" } }}
                    renderOption={(option) => {
                      const selectFilmIndex = newData.typeHouseObject.find(
                        (item) => item.value === option.value
                      );
                      return (
                        <React.Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={Boolean(selectFilmIndex)}
                          />
                          {option.label}
                        </React.Fragment>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" />
                    )}
                  />
                </Grid>
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">點交狀況:</Typography>
                  {newData.edit ? (
                    <Select
                      items={pointHandArray}
                      value={newData.pointHandObject}
                      onChange={(e, value) => {
                        changeData("pointHandObject", value, true);
                      }}
                    />
                  ) : (
                    <Typography>{newData.pointHandObject?.label}</Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container item spacing={1}>
                <Grid item xs={12} sm={3}>
                  <Box display="flex" flexDirection="row" alignItems="flex-end">
                    <Box display="flex" flexDirection="column">
                      <Typography color="primary">需求價格:</Typography>
                      {newData.edit ? (
                        <TextInput
                          value={newData.priceStart}
                          onChange={(v) => changeData("priceStart", v, true)}
                          fullWidth
                        />
                      ) : (
                        <Typography>{newData.priceStart + "萬"}</Typography>
                      )}
                    </Box>
                    <Typography color="primary">～</Typography>
                    <Grid item classes={{ root: classes.DocumentContainerEnd }}>
                      {newData.edit && (
                        <Typography color="primary">萬</Typography>
                      )}
                      {newData.edit ? (
                        <TextInput
                          value={newData.priceEnd}
                          onChange={(v) => changeData("priceEnd", v, true)}
                          fullWidth
                        />
                      ) : (
                        <Typography>{newData.priceEnd + "萬"}</Typography>
                      )}
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box display="flex" flexDirection="row" alignItems="flex-end">
                    <Box display="flex" flexDirection="column">
                      <Typography color="primary">需求地坪:</Typography>
                      {newData.edit ? (
                        <TextInput
                          value={newData.floorStart}
                          onChange={(v) => changeData("floorStart", v, true)}
                          fullWidth
                        />
                      ) : (
                        <Typography>{newData.floorStart + "坪"}</Typography>
                      )}
                    </Box>
                    <Typography color="primary">～</Typography>
                    <Grid item classes={{ root: classes.DocumentContainerEnd }}>
                      {newData.edit && (
                        <Typography color="primary">坪</Typography>
                      )}
                      {newData.edit ? (
                        <TextInput
                          value={newData.floorEnd}
                          onChange={(v) => changeData("floorEnd", v, true)}
                          fullWidth
                        />
                      ) : (
                        <Typography>{newData.floorEnd + "坪"}</Typography>
                      )}
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Box display="flex" flexDirection="row" alignItems="flex-end">
                    <Box display="flex" flexDirection="column">
                      <Typography color="primary">需求建坪:</Typography>
                      {newData.edit ? (
                        <TextInput
                          value={newData.jianpingStart}
                          onChange={(v) => changeData("jianpingStart", v, true)}
                          fullWidth
                        />
                      ) : (
                        <Typography>{newData.jianpingStart + "坪"}</Typography>
                      )}
                    </Box>
                    <Typography color="primary">～</Typography>
                    <Grid item classes={{ root: classes.DocumentContainerEnd }}>
                      {newData.edit && (
                        <Typography color="primary">坪</Typography>
                      )}
                      {newData.edit ? (
                        <TextInput
                          value={newData.jianpingEnd}
                          onChange={(v) => changeData("jianpingEnd", v, true)}
                          fullWidth
                        />
                      ) : (
                        <Typography>{newData.jianpingEnd + "坪"}</Typography>
                      )}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1} alignItems={"flex-end"}>
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">案名:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.caseName}
                      onChange={(v) => changeData("caseName", v, true)}
                      fullWidth
                    />
                  ) : (
                    <Typography>{newData.caseName}</Typography>
                  )}
                </Grid>
                <Grid xs={5} sm={2} item>
                  <Typography color="primary">樓層:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.floor}
                      onChange={(v) => changeData("floor", v, true)}
                      fullWidth
                    />
                  ) : (
                    <Typography>{newData.floor}</Typography>
                  )}
                </Grid>
                {"樓\u2002"}
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">電梯:</Typography>
                  {newData.edit ? (
                    <Select
                      items={elevatorArray}
                      value={newData.elevatorObject}
                      onChange={(e, value) =>
                        changeData("elevatorObject", value, true)
                      }
                    />
                  ) : (
                    <Typography>{newData.elevatorObject?.label}</Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1} alignItems={"flex-end"}>
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">屋況:</Typography>
                  {newData.edit ? (
                    <Select
                      items={houseStateArray}
                      value={newData.houseStateObject}
                      onChange={(e, value) =>
                        changeData("houseStateObject", value, true)
                      }
                    />
                  ) : (
                    <Typography>{newData.houseStateObject?.label}</Typography>
                  )}
                </Grid>
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">車位:</Typography>
                  {newData.edit ? (
                    <Select
                      items={parkingArray}
                      value={newData.parkingObject}
                      onChange={(e, value) =>
                        changeData("parkingObject", value, true)
                      }
                    />
                  ) : (
                    <Typography>{newData.parkingObject?.label}</Typography>
                  )}
                </Grid>
                <Grid xs={6} sm={2} item>
                  <Typography color="primary">管理員:</Typography>
                  {newData.edit ? (
                    <Select
                      items={adminArray}
                      value={newData.adminObject}
                      onChange={(e, value) =>
                        changeData("adminObject", value, true)
                      }
                    />
                  ) : (
                    <Typography>{newData.adminObject?.label}</Typography>
                  )}
                </Grid>
                <Grid xs={11} sm={1} item>
                  <Typography color="primary">房數:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.room}
                      onChange={(v) => changeData("room", v, true)}
                      fullWidth
                    />
                  ) : (
                    <Typography>{newData.room + "房"}</Typography>
                  )}
                </Grid>
                {newData.edit && "房\u2002"}
                <Grid xs={11} sm={1} item>
                  {newData.edit ? (
                    <TextInput
                      value={newData.hall}
                      onChange={(v) => changeData("hall", v, true)}
                      fullWidth
                    />
                  ) : (
                    <Typography>{newData.hall + "廳"}</Typography>
                  )}
                </Grid>
                {newData.edit && "廳\u2002"}
                <Grid xs={11} sm={1} item>
                  {newData.edit ? (
                    <TextInput
                      value={newData.guard}
                      onChange={(v) => changeData("guard", v, true)}
                      fullWidth
                    />
                  ) : (
                    <Typography>{newData.guard + "衛"}</Typography>
                  )}
                </Grid>
                {newData.edit && "衛\u2002"}
                <Grid xs={11} sm={1} item>
                  <Typography color="primary">管理費:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.managementFee}
                      onChange={(v) => changeData("managementFee", v, true)}
                      fullWidth
                    />
                  ) : (
                    <Typography>{newData.managementFee + "元"}</Typography>
                  )}
                </Grid>
                {newData.edit && "元\u2002"}
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Grid xs={12} sm={12} item>
                  <Typography color="primary">概述:</Typography>
                  {newData.edit ? (
                    <TextInput
                      value={newData.overView}
                      onChange={(v) => changeData("overView", v, true)}
                      fullWidth
                      multiline
                      rows={3}
                    />
                  ) : (
                    <Typography>{newData.overView}</Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
          </>
        ) : null}
        {newData.edit && (
          <>
            <Divider />
            <CardActions>
              <Grid container item spacing={1} justify="center">
                {!simulationQuery?.id ? (
                  <Grid item>
                    <Button variant="contained" color="primary" onPress={save}>
                      儲存
                    </Button>
                  </Grid>
                ) : (
                  <>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={() => {
                          changeData("edit", false, true);
                        }}
                      >
                        取消
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={save}
                      >
                        確認修改
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </CardActions>
          </>
        )}
        <Divider />
        {simulationQuery?.attributes === "法拍" ||
          (newData.customerAttributesObject.value === "FORECLOSURE" && (
            <TargetPropertyTable id={simulationQuery?.id} />
          ))}
        <Divider />
        <TrackRecordTable
          id={simulationQuery?.id}
          name={`${newData.customerName1 !== "" ? newData.customerName1 : ""}${
            newData.customerName2 !== "" ? "," + newData.customerName2 : ""
          }`}
        />
      </Card>
    );
  }
}
